// extracted by mini-css-extract-plugin
export var productImage = "_xm-0";